import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import createAppStore from './redux/store';
import { Toaster } from 'sonner';

const store = createAppStore();

// --- Cross-tab login detection ---
// When a user logs into a different school in another tab, force this tab to reload
// so it picks up the new session instead of showing stale data.
// The 'storage' event only fires in OTHER tabs (not the current one).
// We only react to a NEW token being set — not to removal — to prevent cascading loops.
window.addEventListener('storage', (event) => {
  if (event.key === 'authorizationToken' && event.newValue && event.newValue !== event.oldValue) {
    // A new/different token was set from another tab — new login happened
    // Redirect to login page so user knows session changed
    window.location.href = '/';
  }
});
// --- End cross-tab login detection ---

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
    <Toaster position="top-center" richColors/> 
    {/* sfsdf */}
    <App />
    </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
